import { OverrideRulesManager } from "@/components/override-rules/override-rules-manager";
import useTranslation from "@babackapp/translations/use-translation";

export function StoreReturnExceptions() {
  const t = useTranslation();

  return (
    <div className="px-4">
      <OverrideRulesManager
        actionType="OVERRIDE_STORE_RETURN"
        title={t("settings.returnToStore.exceptions.title")}
        description={t("settings.returnToStore.exceptions.description")}
        showScope={false}
      />
    </div>
  );
}
